import { useState, useEffect, useContext } from "react";
import verticle_logo from "../../assets/images/200_black.svg";
import banner from "../../assets/images/signinar.jpg";
import spin from "../../assets/images/spin.svg";
import { Input, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";

import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { AuthContext } from "../../contexts/AuthContext";
import Banner from "./components/Banner";
const REACT_APP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
const REACT_APP_TRACE_API_URL = process.env.REACT_APP_TRACE_API_URL;

export default function Signin() {
  const { token, signin, auth } = useContext(AuthContext);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSpinning, setSpinning] = useState(false);
  const access = [4, 5, 9];

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      Cookies.set("token", token);
      if (access.includes(auth?.accessLevel)) {
        navigate("/dashboard");
      } else {
        navigate("/requests");
      }
    }
    if (email.trim() && password.trim()) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [email, password, navigate]);

  const handleSignin = async (e: any) => {
    setSpinning(true);
    e.preventDefault();
    const data = { username: email, password };
    const uri = `auth/login`;

    const res = await fetch(`${REACT_APP_TRACE_API_URL}/${uri}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const response = await res.json();
    if (response.statusCode === 401) {
      message.error("Incorrect email or password");
      setSpinning(false);
      return;
    }
    if (response?.success) {
      await handleLocal(response);
    }

    setSpinning(false);
  };

  const handleLocal = async (data: any) => {
    const uri = `v1/users/verify/${data?.user?.email}`;
    const res = await fetch(`${REACT_APP_BASE_API_URL}/${uri}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    const response = await res.json();
    if (response !== null) {
      const auth = {
        _id: response?.user?._id,
        name: response?.user?.name,
        mobile: response?.user?.mobile,
        email: response?.user?.email,
        cluster: response?.user?.cluster,
        companyNo: response?.user?.companyNo,
        businessUnit: response?.user?.businessUnit,
        businessUnitRef: response?.user?.businessUnitRef,
        legalEntity: response?.user?.legalEntity,
        businessDivision: response?.user?.businessDivision,
        businessSegment: response?.user?.businessSegment,
        department: response?.user?.department,
        accessLevel: response?.user?.accessLevel,
      };

      const credentials = {
        user: data?.user,
        token: data?.token,
        auth: auth,
      };
      signin(credentials);
      message.success(`Logged in sucessfully`);
    } else {
      navigate("/denied");
    }
  };

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13 || e.which === 13) {
      isButtonDisabled || handleSignin(e);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="w-full bg-karimjee">
        <Banner />
      </div>
      <div className="max-w-2xl w-full pt-2 sm:pt-2 px-5">
        <div className="flex flex-row justify-center border rounded-md">
          <div className="p-4 w-full sm:w-1/2 bg-gray-100 rounded-tl-lg rounded-bl-lg">
            <div className="text-center mt-4">
              <img className="mx-auto w-40" src={verticle_logo} alt="" />
              <p className="mt-6">Sign in with email and password </p>
            </div>
            <div className="mb-4">
              <form className="mt-8">
                <input type="hidden" name="remember" value="true" />
                <div className="rounded-md shadow-sm">
                  <div>
                    <Input
                      aria-label="Email"
                      name="email"
                      type="text"
                      size="large"
                      required
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      className="flex flex-row justify-center rounded-t-lg rounded-b-none"
                      placeholder="Email"
                    />
                  </div>
                  <div className="-mt-px">
                    <Input.Password
                      aria-label="Password"
                      name="password"
                      type="password"
                      size="large"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      className="flex flex-row justify-center rounded-b-lg rounded-t-none"
                      placeholder="Password"
                      iconRender={(visible) =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </div>
                </div>

                <div className="mt-6 flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="remember_me"
                      type="checkbox"
                      className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                    />
                    <label className="ml-1 mr-1 block text-sm leading-5 text-gray-900">
                      Remember me
                    </label>
                  </div>
                  <Link
                    to="/forgot"
                    className="text-xs text-center flex items-center text-blue-900 hover:text-auto-blue-dark"
                  >
                    Forgot your Password?
                  </Link>
                </div>

                <div className="border-t border-gray-300  max-w-md mt-4 mb-4 w-full"></div>

                <div className="mt-6 mb-4">
                  <button
                    onClick={(e: any) => handleSignin(e)}
                    className="group relative w-full flex justify-center py-3 sm:py-2 px-4
                border border-transparent text-sm leading-5 font-medium
                rounded-md text-white bg-fish hover:bg-fish-dark
                focus:outline-none focus:border-toyota
                focus:shadow-outline-indigo active:bg-toyota transition
                duration-150 ease-in-out"
                  >
                    <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                      <svg
                        className="h-5 w-5 text-white group-hover:text-whitetransition ease-in-out duration-150"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                        />
                      </svg>
                    </span>
                    {isSpinning ? (
                      <span>
                        <img src={spin} alt="spin" height="20px" width="20px" />
                      </span>
                    ) : (
                      <span className="text-white">Sign in</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="hidden sm:block sm:w-1/2 rounded-tr-lg rounded-br-lg bg-white ">
            <div className="flex flex-col items-center justify-center w-full h-full">
              <div className="relative">
                <div className="">
                  <img
                    src={banner}
                    className="aspect-[2/2.8] object-cover"
                    alt=""
                  />
                </div>
                <div className="flex flex-col absolute bottom-6 left-24">
                  <div className="flex justify-center items-center text-center mb-1 text-xs">
                    APPROVAL MATRIX &
                  </div>
                  <div className="flex justify-center items-center text-center  text-xs">
                    CREDIT CONTROL
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
